











import { Vue, Component, Emit, PropSync } from 'vue-property-decorator'
import { Question, SelectableAnswer } from '../../controllers/Chat'

@Component
export default class SelectableAnswerComponent extends Vue {
  @PropSync('question', { required: true, type: Question })
  syncQuestion: Question
  answer: SelectableAnswer = null
  seletedAnswer = null

  created () {
    this.answer = this.syncQuestion.answer as SelectableAnswer
  }

  @Emit('validAnswer')
  addText () : any {
    console.log(this.seletedAnswer)
    this.answer.value = this.seletedAnswer
    return this.seletedAnswer
  }
}
